import React, { useEffect, useState } from "react";
import {
  AddFlex,
  CustomInput,
  CustomInputArea,
  CustomInputLabel,
  PrimaryActionButton,
} from "../Components/reusableStyles";
import { BoxedTabs } from "../Components/BoxedTabs";
import { CircularProgress, Dialog } from "@mui/material";
import { callNonStoreApi } from "../utils/utils";
import useDialogActions from "../useDialogActions";
import { DeleteHelpVideo, GetHelpVideos } from "../utils/ApiEndpoints";
import VideoCard from "./VideoCard";
import HelpAndSupportDialogComponent from "./HelpAndSupportDialogComponent";
import customClientAxios from "../customAxios";

export const ids = {
  pages: "pages",
  website: "website",
  dashboard: "dashboard",
  marketing: "marketing",
  invoice: "invoice",
  leads: "leads",
  forms: "forms",
  testimonials: "testimonials",
  reports: "reports",
  customers: "customers",
  transactions: "transactions",
  calendar: "calendar",
  integrations: "integrations",
  instagram: "instagram",
};

function HelpAndSupport() {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateVideoData, setUpdateVideoData] = useState(null);
  const { isDialogOpen, openDialog, closeDialog } = useDialogActions();

  const [tabs] = useState(
    Object.values(ids).map((id) => {
      return {
        name: id,
      };
    })
  );
  const handleGetVideoList = async () => {
    setLoading("main");
    const pageId = tabs[selectedTabIndex].name;
    const res = await callNonStoreApi(GetHelpVideos.replace(":id", pageId));
    setVideos(res.data ? res.data.helpVideos : []);
    setLoading(null);
  };

  const handleDeleteVideo = async (id) => {
    setLoading("delete");
    const pageId = tabs[selectedTabIndex].name;
    const res = await customClientAxios().post(
      DeleteHelpVideo.replace(":tag", pageId).replace(":id", id)
    );
    console.log(res);
    setVideos(res.data ? res.data.helpVideos : []);
    setLoading(null);
  };

  useEffect(() => {
    handleGetVideoList();
  }, [forceRefresh, selectedTabIndex]);
  return (
    <>
      <AddFlex flexDirection="column" gap="20px" padding="20px">
        <BoxedTabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={(index) => setSelectedTabIndex(index)}
        />
        <PrimaryActionButton
          onClick={() => {
            openDialog();
          }}
          style={{ width: "max-content", margin: "0 0 0 auto" }}
        >
          Add Video
        </PrimaryActionButton>
        {loading === "main" ? (
          <CircularProgress />
        ) : (
          videos?.map((video) => (
            <AddFlex flexDirection="column" width="50%">
              <VideoCard
                loading={loading}
                video={video}
                updateVideo={() => {
                  setUpdateVideoData(video);
                  openDialog();
                }}
                deleteVideo={async () => {
                  await handleDeleteVideo(video.id);
                }}
              />
            </AddFlex>
          ))
        )}
      </AddFlex>
      <Dialog
        open={isDialogOpen}
        onClose={() => {
          closeDialog();
          setUpdateVideoData(null);
        }}
        PaperProps={{
          sx: {
            padding: "20px",
            width: "50vw",
            height: "60vh",
          },
        }}
      >
        <HelpAndSupportDialogComponent
          video={updateVideoData}
          tag={tabs[selectedTabIndex].name}
          setForceRefresh={setForceRefresh}
          closeDialog={() => {
            closeDialog();
            setUpdateVideoData(null);
          }}
        />
      </Dialog>
    </>
  );
}

export default HelpAndSupport;
